export function gettitle(title) {
    // console.log('___vtitle', title)
    let vtitle = ''
    if (title && title.title) {
        vtitle = title.title
    } else {
        vtitle = title
    }
    if (vtitle.includes('/')) {
        let text = vtitle.split('/')
        this.extend = text[1]
        return text[0]
    } else {
        return vtitle
    }
}
export function tomore() {
    this.$emit('tomore')
}